import { jsx } from "react/jsx-runtime";
import { css } from "@/styled-system/css";
import { Box } from "@zillow/constellation-10";
import { forwardRef } from "react";
const overlappingStackStyles = css.raw({
  display: "grid",
  "& > *": {
    gridArea: "1 / 1"
  }
});
const OverlappingStack = forwardRef(function OverlappingStack2({
  css: cssProp,
  className,
  ...props
}, ref) {
  return /* @__PURE__ */ jsx(Box, { ...props, ref, css: {
    ...overlappingStackStyles,
    ...cssProp
  }, className });
});
export {
  OverlappingStack as default
};
